<template>
  <div class="download-popup-52000__top-img-wrap">
    <img :src="getImageUrlWithCDN_LOCAL('/home2/download_popup_top_img.webp')" class="download-popup-52000__top-img" alt="" />
  </div>

  <div class="download-popup-52000">
    <div class="download-popup-52000__header">
      <div class="download-popup-52000__logo-wrap">
        <img :src="downloadPopupLogoUrl" class="download-popup-52000__logo" alt="" />
      </div>
    </div>

    <h2 class="download-popup-52000__title">Adicionar à tela ini</h2>

    <p class="download-popup-52000__desc">
      Gostaríamos de adicionar o {{ GameWebLink }} à sua tela inicial para as últimas apostas grátis e atualizações de bônus.
    </p>

    <div class="download-popup-52000__actions">
      <button type="button" class="download-popup-52000__btn download-popup-52000__btn--outline" @click="emit('close')">Cancelar</button>
      <button type="button" class="download-popup-52000__btn download-popup-52000__btn--primary" @click="emit('install')">Instalar</button>
    </div>
  </div>
</template>

<script setup>
import { downloadPopupLogoUrl } from './js/index.js'

const GameWebLink = computed(() => {
  return JSON.parse(localStorage.getItem('localConfig')).gameWebLink
})

const emit = defineEmits(['install', 'close'])
</script>

<style lang="less" scoped>
.download-popup-52000__top-img-wrap {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 320px;
  z-index: 0;
  overflow: visible;
  pointer-events: none;

  .download-popup-52000__top-img {
    position: absolute;
    top: 0;
    left: 50%;
    width: 230px;
    height: auto;
    transform: translateX(-54.65%);
    pointer-events: none;
    user-select: none;
  }
}

.download-popup-52000 {
  position: absolute;
  bottom: 0;
  z-index: 1;
  width: 100%;
  height: 240px;
  padding: 0 20px max(28px, env(safe-area-inset-bottom));
  box-sizing: border-box;
  background: linear-gradient(180deg, #d0fc5e, #ffffff);
  border-radius: 20px 20px 0 0;

  &__header {
    position: relative;
    top: -36px;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }

  &__logo-wrap {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 94px;
    height: 94px;
    margin-bottom: -24px;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.14);
    box-shadow:
      inset 0 0 0 1px rgba(255, 255, 255, 0.5),
      inset 0 0 16px 0 rgba(255, 255, 255, 1);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
  }

  &__logo {
    width: 84px;
    height: 84px;
    border-radius: 12px;
    object-fit: cover;
  }

  &__title {
    font-size: 16px;
    font-weight: 700;
    line-height: 1.3;
    text-align: center;
    color: #1b1b1b;
  }

  &__desc {
    margin-top: 16px;
    padding: 0 4px;
    font-size: 14px;
    line-height: 1.25;
    color: #647040;
  }

  &__actions {
    margin-top: 20px;
    display: flex;
    gap: 12px;
  }

  &__btn {
    flex: 1;
    height: 44px;
    border-radius: 22px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;

    &--outline {
      border: 1px solid #1b1b1b;
      color: #1b1b1b;
    }

    &--primary {
      border: none;
      background: #1b1b1b;
      color: #ffffff;
    }
  }
}
</style>
